/** Макрос Weborama в ссылках баннера, вместо него подставляется случайное число против кеширования */
export const RANDOM_MACRO = '[RANDOM]';

/** Границы случайного числа для макроса Weborama */
export const RANDOM_MACRO_MIN = 1;
export const RANDOM_MACRO_MAX = 1e10;
